module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJklEQVQ4jWMYBaOACoARZMT/PJsGSoxinHSkgWk0NkbBoAEMDAwA5fQEBJXU8kgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_btn_minus.png
// module id = 308
// module chunks = 0